import { fabric } from 'fabric';

fabric.PathMask = fabric.util.createClass(fabric.Path, {
    type: 'pathMask'
});
